export enum EntryAndExitTypes {
  None = 0,
  Entry = 1,
  Exit = 2
}

export function getEntryAndExitTypeName(value: EntryAndExitTypes): string {
  switch (value) {
    case EntryAndExitTypes.None: return '不明';
    case EntryAndExitTypes.Entry: return '入室';
    case EntryAndExitTypes.Exit: return '退室';
  }
}
